import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "../../axios-api";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Spinner from "../UI/Spinner/Spinner";
let id = "";
let data = "";
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  componentDidMount() {
    this.setState({ loading: true,alertpopup:true });
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    const windowUrl = window.location.hash;

    let paramString = windowUrl.split("?")[1];
    if (paramString != undefined) {
      var queryParams = paramString.split("&").reduce(function (q, query) {
        // var chunks = query.split("=");
        // var key = chunks[0];
        // if (key.toLowerCase() === "dt") {
        var value = decodeURIComponent(query.slice(3));
        value = isNaN(Number(value)) ? value : Number(value);
        if (value !== undefined) data = value;
        // }

        return value;
      }, {});
    }
    if (data !== undefined && data !== "") {
      let Param = {
        BookingID: data,
      };
      axios
        .post("/IstifadaPayment/InProcessRoomBooking", Param)
        // .post("/Payment/initialize", config)
        .then((res) => {
          // debugger;
          if (res.data.status === 1) {
            id = res.data.id;
            let options = JSON.parse(res.data.options);
            options.handler = (response) => {
              axios
                .post("/IstifadaPayment/confirm", response)
                .then((res) => {
                  if (res.data.result === "1") {
                    this.getReturnURL(res.data);
                    this.setState({ loading: false,alertpopup:false });
                  } else {
                    this.closeCheckout();
                    // toast.error("Error in accessing data");
                    this.setState({ loading: false,alertpopup:false });
                  }
                })
                .catch((err) => {
                  toast.error(err);
                  this.setState({ loading: false });
                });
            };
            options.modal = {
              ondismiss: () => {
                this.closeCheckout();
              },
            };
            // options.readonly = {
            //   name: true,
            //   email: true,
            //   contact: true,
            // };

            const rzp2 = new window.Razorpay(options);
            rzp2.on("payment.failed", function (response) {
              this.setState({ loading: false });
              this.closeCheckout();
              //cancel payment
              // alert(response.error.code);
              // alert(response.error.description);
              // alert(response.error.source);
              // alert(response.error.step);
              alert(response.error.reason);
              // alert(response.error.metadata.order_id);
              // alert(response.error.metadata.payment_id);
            });
            rzp2.open();
            // this.setState({
            //   loading: false,
            // });
          } else {
            toast.error(<>{res.data.msg}</>);
            this.setState({ loading: false });
          }
        })
        .catch((err) => {
          toast.error("Error in accessing data");
          window.location.reload();
          this.setState({ loading: false });
        });
    }
  }

  closeCheckout = () => {
    const param = {
      SearchKey: data,
    };
    axios
      .post("/IstifadaPayment/cancel", param)
      .then((res) => {
        if (res.data.result === "1") {
          this.getReturnURL(res.data);
          this.setState({ loading: false });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        toast.error("Error in accessing data");
        this.setState({ loading: false });
      });
  };

  getReturnURL = (data) => {
    let encoded = encodeURIComponent(data.data).replace(/%../g, (match) =>
      match.toLowerCase()
    );
    let url = data.msg + encoded;
    // var windowReference = window.open();
    window.location = url;
  };

  render() {
    return (
      <>
        {this.state.loading === true ? <Spinner /> : null}
        <Modal
          show={this.state.alertpopup}
          onHide={() => {
            this.setState({ alertpopup: false });
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          // centered
          scrollable
          className=""
          data-lenis-prevent="true"
          onShow={this.stopScroll}
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="lh-base text-center">
              <b>Do Not Close or Refresh This Page</b>
            </div>
          </Modal.Body>
          
        </Modal>
      </>
    );
  }
}

export default Login;
